// extracted by mini-css-extract-plugin
export var container = "header-logos-module--container--z30QV";
export var imageBox = "header-logos-module--image-box--xREf4";
export var ratio = "header-logos-module--ratio--tO6A4";
export var small = "header-logos-module--small--z0Bqb";